import * as React from 'react'
import { css, Global, withTheme } from '@emotion/react'

const FormCss = withTheme(() => (
  <Global
    styles={css`
      .hubspot-form {
        width: 100%;
      }
    `}
  />
))

export default FormCss
